module.exports = __webpack_public_path__ + "img/zoom.c4ee51ac.png";